import ToolBars from './module/toolBars.vue'

export default {
  name: 'Tree',
  props: {
    departData: {
      type: Object | Array,
      require: true
    },
    departChildData: {
      type: Object | Array,
      require: true
    },
    id: {
      type: Number | String,
      require: true
    },
    num: {
      type: Number,
      require: true
    },
    type: {
      type: String,
      require: false
    },
    title: {
      type: String,
      require: true
    },
    lastItem: {
      type: Boolean,
      require: true
    },
    hasOneChild: {
      type: Boolean,
      require: true
    },
    hasMoreChild: {
      type: Boolean,
      require: true
    }
  },
  components: {
    ToolBars
  },
  data() {
    return {
      isExpend: true,
      tree: []
    }
  },
  created() {
    this.tree = this.departChildData
  },
  computed: {
    hasPad() {
      return this.id != 0 ? ' pad20' : ''
    },
    showFoldLine() {},
    showFlodIcon() {
      return this.tree.length > 0 ? (!this.isExpend ? 'icon-expand' : 'icon-collapse') : ''
    },
    showFoldChild() {
      if (this.id === 0) {
        return 'icon-short-line'
      }
      if (this.hasOneChild) {
        return 'icon-L'
      }
      return this.lastItem ? 'icon-L' : 'icon-T'
    }
  },
  methods: {
    handleNodeClick(data) {
      if (this.type === 'layer') {
        this.$EventBus.$emit('eventSelectDepart', data.id, data)
      }
    },
    rollData() {
      this.isExpend = !this.isExpend
    },
    addItem(id, item) {
      this.$EventBus.$emit('eventAddChildDepart', id, item)
    },
    editItem(parentId, parentItem, item) {
      this.$EventBus.$emit('eventEditDepart', parentId, parentItem, item)
    },
    deleteItem(id) {
      this.$EventBus.$emit('eventDelDepart', id)
    }
  },
  mounted() {},
  watch: {
    departChildData: {
      handler(n) {
        if (n) {
          this.tree = n
        }
      },
      immediate: true,
      deep: true
    }
  }
}
